var join = function (glue) {
    var apply = function (input) { return input.join(glue); };
    return apply;
};
export default join;
